import TemplateView from '../../../../../js/TemplateView'
import SharedFeedsTableHeader from './SharedFeedsTableHeader'
import AllFeedsTableHeader from './AllFeedsTableHeader'
import {DEFAULT_SORTING, ICalTabType} from '../../constants'
import {connect} from '../../../../../js/redux/utils'
import {
    getActiveTab,
    getAllFeedsForTable,
    getAllFeedsSorting,
    getSharedFeedsForTable,
    getSharedFeedsSorting,
} from '../../selectors'
import {bindActionCreators} from 'redux'
import {changeAllSorting, changeSharedSorting, editFeed, getFeedUrl} from '../../actions'
import AllFeedsRow from './AllFeedsRow'
import SharedFeedsRow from './SharedFeedsRow'
import FeedsTableContent from './FeedsTableContent'
import {openEditFeedLightBox} from '../lightbox/actions'

class FeedsTable extends TemplateView {

    constructor({
        editFeed,
        changeAllSorting,
        changeSharedSorting,
        getFeedUrl,
        openEditFeedLightBox,
    }) {
        super()

        this.state = {
            activeTab: ICalTabType.USER_FEEDS,
            allFeeds: [],
            sharedFeeds: [],
            allSorting: DEFAULT_SORTING,
            sharedSorting: DEFAULT_SORTING,
        }

        this.actions = {
            editFeed,
            changeAllSorting,
            changeSharedSorting,
            getFeedUrl,
            openEditFeedLightBox,
        }

        this.onStatePropertyChanged('activeTab', activeTab => {
            this.$sharedFeedsWrapper.toggle(activeTab === ICalTabType.USER_FEEDS)
            this.$allFeedsWrapper.toggle(activeTab === ICalTabType.ALL_FEEDS)
        })

        this.onStatePropertyChanged('allFeeds', feeds => {
            this.allFeedsContent.setState({feeds})
        })

        this.onStatePropertyChanged('sharedFeeds', feeds => {
            this.sharedFeedsContent.setState({feeds})
        })

        this.onStatePropertyDeeplyChanged('allSorting', sorting => {
            this.allFeedsHeader.setState({sorting})
            this.allFeedsContent.setState({sorting})
        })

        this.onStatePropertyDeeplyChanged('sharedSorting', sorting => {
            this.sharedFeedsHeader.setState({sorting})
            this.sharedFeedsContent.setState({sorting})
        })
    }

    templateHtml() {
        return `<div class='feedsTable'>
                    <div class='allFeedsWrapper'/>
                    <div class='sharedFeedsWrapper'/>
                </div>`
    }

    afterRender() {
        this.$allFeedsWrapper = this.find('.allFeedsWrapper')
        this.$sharedFeedsWrapper = this.find('.sharedFeedsWrapper')

        this.sharedFeedsHeader = new SharedFeedsTableHeader({
            changeSorting: this.actions.changeSharedSorting,
        }).init(this.$sharedFeedsWrapper)
        this.sharedFeedsContent = new FeedsTableContent({
            renderFeed: feed => new SharedFeedsRow({
                feed,
                users: this.state.users,
                userGroups: this.state.userGroups,
                timeZoneGroups: this.state.timeZoneGroups,
                leaveTypes: this.state.leaveTypes,
                getFeedUrl: this.actions.getFeedUrl,
            }),
        }).init(this.$sharedFeedsWrapper)

        this.allFeedsHeader = new AllFeedsTableHeader({
            changeSorting: this.actions.changeAllSorting,
        }).init(this.$allFeedsWrapper)
        this.allFeedsContent = new FeedsTableContent({
            renderFeed: feed => new AllFeedsRow({
                feed,
                users: this.state.users,
                userGroups: this.state.userGroups,
                timeZoneGroups: this.state.timeZoneGroups,
                leaveTypes: this.state.leaveTypes,
                onEditClick: this.actions.openEditFeedLightBox,
            })
        }).init(this.$allFeedsWrapper)
    }
}

export default connect(
    state => ({
        activeTab: getActiveTab(state),
        allFeeds: getAllFeedsForTable(state),
        sharedFeeds: getSharedFeedsForTable(state),
        allSorting: getAllFeedsSorting(state),
        sharedSorting: getSharedFeedsSorting(state),
    }),
    dispatch => bindActionCreators({
        editFeed,
        changeAllSorting,
        changeSharedSorting,
        getFeedUrl,
        openEditFeedLightBox,
    }, dispatch)
)(FeedsTable)



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/components/table/FeedsTable.js